
import { useCallback } from 'react';
import { customAuthAxios } from '../../utils/customAuthAxios';

export const useUpdateFirstView = () => {
    const updateFirstView = useCallback(async (restaurantId: string, firstViewId: string) => {
        try {
            const uploadData = {
                restaurant_id: restaurantId,
                first_view_id: firstViewId
            };
            const response = await customAuthAxios.post('general_setting/first-view/update_display_setting/', uploadData);
            return response.data;
        } catch (error: any) {
            console.error('開始画面更新エラー:', error);
            console.error('エラーレスポンス:', error.response?.data);
            throw error;
        }
    }, []);

    return updateFirstView;
};